$(document).ready(function () {
    pageMain.init();
    MiniGame.init();
});

window.pageMain = (function(){
    const init = ()=>{
        quick();
        select();
    };
    const quick = ()=>{
        let $menu = $('.quick__item'),
            $btnTop = $('.quick__top'),
            $doc = $('html, body'),
            $contents = $('.section-1, .section-2, .section-3');
        let sclTop = $(window).scrollTop(),
            fixTop = $('.p-header').offset().top + $('.p-header').height();

        if (!(fixTop <= sclTop)) $menu.removeClass('active');
        $menu.on('click', 'a', function(e){
            e.preventDefault();
            let target = $(this).attr("href"),
                offsetTop = $(target).offset().top;
            $doc.stop().animate({ scrollTop :offsetTop }, 800);
        });
        $(window).scroll(function(){
            sclTop = $(window).scrollTop();
            $.each($contents, function(idx, item){
                let $target = $contents.eq(idx),
                    i = idx,
                    targetTop = $target.offset().top;

                if (targetTop <= sclTop) {
                    $menu.removeClass('active');
                    $menu.eq(i).addClass('active');
                }
                if (!(fixTop <= sclTop)) $menu.removeClass('active');
            });
            sclTop >= fixTop ? $('.quick').addClass('quick--fix') : $('.quick').removeClass('quick--fix');
        });
        $btnTop.on('click', function(e){
            e.preventDefault();
            $doc.stop().animate({ scrollTop : 0 }, 800);
        });
    };
    const select = ()=>{
        let $list, $selectBox;

        $(document).on('click', '.select__open', function(){
            $list = $(this).closest('.select').find('.select__list');
            $list.is(':visible') ? $list.hide() : $list.show();
        });
        $(document).on('click', '.select__list a', function(){
            $selectBox = $(this).closest('.select');

            $selectBox.find('.select__list').hide();
            $selectBox.find('.select__open').text( $(this).text() );
        });
    };

    return{
        init
    }
})();


window.MiniGame = (function(){
    let Info = {
        message1: '100% 응원선물을 획득하였습니다.',
        message2: '유니폼 1개를 획득하였습니다.',
        message3: '다이노스틱 1개를 획득하였습니다.',
        message4: '야구배트 1개를 획득하였습니다.',
        message5: '프로텍터 1개를 획득하였습니다.',
        message6: '글러브 1개를 획득하였습니다.',
        message7: '야구공 1개를 획득하였습니다.',
        sequenceFlag: false
    };

    const init = function(){
        sequence.init();
        bindEvent();
    };

    const sequence = (()=>{
        let effect;

        const init = ()=>{
            effect = promokit.sequenceplayer({
                el: '#effect',
                path: promokit.store('staticPath') + '/promo/event/2020/200513_unity/img/effect-1',
                prefix: 'light_',
                frame: 27,
                fps: 60,
            });

            effect.on('ready', ()=>{
                Info.sequenceFlag = true;
            });



            $('#effect').css('visibility', 'hidden');
        };

        const play = ()=>{
            $('#effect').css('visibility', 'visible');
            effect.seek(0);
            effect.play();
            effect.on('end', ()=>{
                $('#effect').css('visibility', 'hidden');
            });
        };

        return{
            init, play
        }
    })();


    const Alert = (function(){
        let $cont = $('.mini-game');

        const open = function(val, msg){
            if( $('.mini-game__alert').length ) Alert.close();
            if( !$cont.hasClass('disabled') ) $cont.addClass('disabled');

            switch (val) {
                case 'case1':
                    $cont.append( Tmpl.case1() );
                    break;
                case 'case2':
                    $cont.append( Tmpl.case2() );
                    break;
                case 'case3':
                    $cont.append( Tmpl.case3() );
                    break;
                case 'case4':
                    $cont.append( Tmpl.case4() );
                    break;
                case 'case5':
                    $cont.append( Tmpl.case5() );
                    break;
                case 'case6':
                    $cont.append( Tmpl.case6() );
                    break;
                case 'result':
                    if( Info.sequenceFlag ){
                        sequence.play();
                        setTimeout(()=>{
                            $cont.append( Tmpl.result(msg) );
                        }, 300);
                    }
                    else{
                        open('loading');
                        setTimeout(()=>{
                            open('result', msg);
                        }, 1000);
                    }
                    break;
                case 'end':
                    if( Info.sequenceFlag ){
                        sequence.play();
                        setTimeout(()=>{
                            $cont.append( Tmpl.end() );
                        }, 300);
                    }
                    else{
                        open('loading');
                        setTimeout(()=>{
                            open('end');
                        }, 1000);
                    }
                    break;
                case 'loading':
                    $cont.append( Tmpl.loading() );
                    break;
            }
        };
        const close = function (){
            if( $cont.find('.mini-game__alert').length ) $cont.find('.mini-game__alert').remove();
            $cont.removeClass('disabled');
        };

        return{
            open, close
        }
    })();

    const bindEvent = function(){
        $(document).on('click', '.mini-game__btn-confirm, .mini-game__btn-close, .mini-game__btn-back', Alert.close );

    };

    const Tmpl = (function(){
        let tag;

        const case1 = function(){
            tag = [];
            tag.push('<div class="mini-game__alert mini-game__alert--1">');
            tag.push('  <p class="mini-game__text">개봉 시, 응원상자 1개가 소모됩니다.</p>');
            tag.push('  <button class="mini-game__btn-confirm mini-game__btn-confirm--tyoe">확인</button>');
            tag.push('  <button class="mini-game__btn-close">취소</button>');
            tag.push('</div>');
            return tag.join('');
        };
        const case2 = function(){
            tag = [];
            tag.push('<div class="mini-game__alert mini-game__alert--2">');
            tag.push('  <p class="mini-game__text">응원상자 개수를 확인해 주세요!</p>');
            tag.push('  <button class="mini-game__btn-confirm">확인</button>');
            tag.push('</div>');
            return tag.join('');
        };
        const case3 = function(){
            tag = [];
            tag.push('<div class="mini-game__alert mini-game__alert--3">');
            tag.push('  <p class="mini-game__text">오류가 발생하였습니다. 잠시 후 시도해 주세요!</p>');
            tag.push('  <button class="mini-game__btn-confirm">확인</button>');
            tag.push('</div>');
            return tag.join('');
        };
        const case4 = function(){
            tag = [];
            tag.push('<div class="mini-game__alert mini-game__alert--4">');
            tag.push('  <p class="mini-game__text">참여 대상이 아닙니다.</p>');
            tag.push('  <button class="mini-game__btn-confirm">확인</button>');
            tag.push('  <button class="mini-game__btn-close">취소</button>');
            tag.push('</div>');
            return tag.join('');
        };
        const case5 = function(){
            tag = [];
            tag.push('<div class="mini-game__alert mini-game__alert--5">');
            tag.push('  <p class="mini-game__text">Plaync게임 선택 이후에 도전 가능합니다.</p>');
            tag.push('  <button class="mini-game__btn-confirm">확인</button>');
            tag.push('</div>');
            return tag.join('');
        };
        const result = function(message){
            tag = [];
            tag.push('<div class="mini-game__alert mini-game__alert--result">');
            tag.push('  <p class="mini-game__text mini-game__text--type">'+message+'</p>');
            tag.push('  <button class="mini-game__btn-back">돌아가기</button>');
            tag.push('</div>');
            return tag.join('');
        };
        const end = function(){
            tag = [];
            tag.push('<div class="mini-game__alert mini-game__alert--end">');
            tag.push('  <p class="mini-game__text">아쉽네요. 다음에 다시 도전해 보세요</p>');
            tag.push('  <button class="mini-game__btn-back">돌아가기</button>');
            tag.push('</div>');
            return tag.join('');
        };
        const loading = function(){
            tag = [];
            tag.push('<div class="mini-game__alert mini-game__alert--loading">');
            tag.push('  <p class="mini-game__text">기다려주세요!</p>');
            tag.push('</div>');
            return tag.join('');
        };
        return{
            case1, case2, case3, case4, case5, result, end, loading
        }
    })();


    return{
        init, Alert, Info
    }
})();


// WEBPACK FOOTER //
// ./src/js/index.js